var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 27",
    clipPath: "url(#clip0_462_2875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7863 17.4261C11.1304 17.8163 7.46337 17.8163 3.80745 17.4261C2.34967 17.2705 1.19824 16.1191 1.04265 14.6612C0.65245 11.0052 0.65245 7.33837 1.04265 3.68245C1.19824 2.22467 2.34967 1.07324 3.80745 0.917651C7.46337 0.52745 11.1302 0.52745 14.7862 0.917651C16.2441 1.07324 17.3955 2.22467 17.5511 3.68245C17.9413 7.33837 17.9413 11.0052 17.5511 14.6612C17.3955 16.1191 16.2442 17.2705 14.7863 17.4261Z",
    fill: "url(#paint0_linear_462_2875)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.13281 7.45312H6.39629V14.4702H4.13281V7.45312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4104 7.30469C10.7516 7.30469 10.023 8.22659 9.83963 8.50724V7.45571H7.75391V14.4728H10.0175V10.9481C10.0175 9.92955 10.4864 9.13728 11.3757 9.13728C12.2648 9.13728 12.4104 10.1235 12.4104 11.3362V14.4728H14.674V9.5683C14.674 8.31814 13.6605 7.30469 12.4104 7.30469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.61273 5.22245C6.61273 5.96659 6.00956 6.56976 5.26542 6.56976C4.52127 6.56976 3.91797 5.96659 3.91797 5.22245C3.91797 4.4783 4.52127 3.875 5.26542 3.875C6.00956 3.875 6.61273 4.4783 6.61273 5.22245Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_2875",
    x1: 6.42545,
    y1: 3.02835,
    x2: 10.7489,
    y2: 12.2786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066B2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_462_2875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0938,
    height: 17.0938,
    fill: "white",
    transform: "translate(0.75 0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn3);
export default __webpack_public_path__ + "static/media/In3.9379a24b7e0be95ff9b4e4e72c577790.svg";
export { ForwardRef as ReactComponent };